import { CartSubmit } from '@ui/cart';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../authorization/use-user.ts';
import { useMediaQuery } from '@uidotdev/usehooks';
import { useSetAtom } from 'jotai/index';
import { loginModalAtom } from '@app/atoms/app/app.atom.ts';

export const CartSubmitButton = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useUser();
  const setIsOpen = useSetAtom(loginModalAtom);

  const isMobile = useMediaQuery('only screen and (max-width : 1023px)');

  return (
    <CartSubmit
      variant="cart"
      onPress={() => {
        if (isMobile) {
          navigate(isAuthenticated ? '/cart/checkout' : '/authorization');
        } else {
          if (isAuthenticated) {
            navigate('/cart/checkout');
          } else {
            setIsOpen(true);
          }
        }
      }}
    />
  );
};
